export const validateEmail = (email) => {
  if (!email?.trim()) return "Email is required.";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
    return "Please enter a valid email.";
  return "";
};

export const validatePassword = (password) => {
  if (!password?.trim()) return "Password is required.";
  if (password.length < 4) return "Password must be at least 4 characters.";
  return "";
};

export function validateLogin(email, password) {
  const emailError = validateEmail(email);
  const passwordError = validatePassword(password);
  if (emailError) return emailError;
  if (passwordError) return passwordError;
  return null;
}
